import { scrollToID } from "../Helper/helper";

export let ImageFilter = {
  /**
   * Init image filters
   */
  initFilters: function () {
    const that = this;
    const mbImageFilters = document.querySelectorAll(
      ".image-filter-content-link"
    );

    for (let i = 0; i < mbImageFilters.length; i++) {
      mbImageFilters[i].addEventListener("click", function (event) {
        /**
         * TODO: animate swing, klick button
         */
        that.filterStores(event.target);
        that.scrollToMap(event.target);
      });
    }
  },

  /**
   * filter stores via ajax
   * @param {dom} target
   */
  filterStores: function (target) {
    const filter = document.getElementById(target.dataset.filter);

    filter.click();
  },

  /**
   * filter stores via ajax
   * @param {dom} target
   */
  scrollToMap: function (target) {
    scrollToID(target.dataset.map, -50);
    // var $map = $(target.dataset.map);

    // $("html, body")
    //   .stop()
    //   .animate(
    //     {
    //       scrollTop: $map.offset().top - 50,
    //     },
    //     900,
    //     "swing",
    //     function () {}
    //   );
  },
};
